<template>
  <v-layout :class="{'fill-height': showPlaceholder}">
    <v-layout v-if="showPlaceholder" justify-center align-center column fill-height>
      <h3 class="headline font-weight-regular text-xs-center">
        {{ message }}
      </h3>
      <v-flex xs6 sm4>
        <img :src="placeholderImg" class="image-placeholder" alt="Placeholder de Erro">
      </v-flex>
    </v-layout>
    <slot v-else/>
  </v-layout>
</template>

<script>
/**
 * @group Resquest Flow Control
 * Trata resposta para quando houver erro ou vazio mostrando por padrão
 * um placeholder com a imagem do logo da Maple Bear e uma mensagem condizente
 * ao problema.
*/
export default {
  name: 'ResquestResponsePlaceholder',

  props: {
    // Messagem de notificação ao usuário
    message: {
      type: String,
      default: 'Houve um problema ao realizar a solicitação.'
    },
    // Status de visualização do placeholder
    showPlaceholder: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    placeholderImg () {
      return require('@/assets/images/placeholders/bear.svg')
    }
  }
}
</script>

<style lang="stylus" scoped>
.image-placeholder
  width 100%
</style>
